module.exports = __webpack_public_path__ + "img/logo_navbar.fa7a7b89.png";